export const env = 'production';

export let appUrl, apiBaseUrl, apiUrlV2;

if (env === 'development') {
  appUrl = 'http://localhost:3000';
  apiBaseUrl = 'http://' + window.location.hostname + ':3333';
  apiUrlV2 = `http://orbitsites.test/api`;
} else {
  appUrl = 'https://trekkscan.principleacs.com';
  apiBaseUrl = 'https://api.' + window.location.hostname + '';
  apiUrlV2 = `https://tk-api-v2.9t6.in/api`;
}

export const apiUrl = `${apiBaseUrl}/api`;
export const brandName = 'TrekkScan';
export const companyName = 'PrincipleACS';
export const copyrightYear = 2016;
export const pageTitleSuffix = ` | ${brandName}`;
export const appVersion = '1.0.1';
export const googleMapsApiKey = 'AIzaSyCeieRJ0hZVs3_OMqx5XPCQtI9UHz4aFbI';
export const bingMapsApiKey = 'Aj4QQqpu0-17k6H6OXE4KFoSshs4utO1k3WXIWD_BObfRKIy5jkD0K8Jn6Upe0ZA';
export const pdfJsLicenseKey = 'Y4lLh43AZEee3d5g1EfQ';

export const appFeatures = {
  fullScreenButton: false,
  notifications: true,
  reportInPopup: false,
  requireAuthorization: false,
  requireEmployeeCode: false,
  search: true,
  shop: true,
};

export const utcOffset = 330;
export const valueNA = 'NA1';

export const dateFormats = {
  timeZone: 'Asia/Kolkata',

  in: {
    date: 'YYYY-MM-DD',
    time: 'HH:mm:ss',
    datetime: 'YYYY-MM-DD HH:mm:ss',
    iso8601: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  },

  out: {
    date: 'MMM D, YYYY',
    date_full: 'DD-MM-YYYY',
    time: 'HH:mm',
    time_meridian: 'hh:mm A',
    date_proper: 'DD-MM-YYYY',
    datetime: 'DD-MM-YYYY hh:mm A',
    date_fns: 'dd-MM-yyyy',
    datetime_fns: 'dd-MM-yyyy HH:mm',
    datetime_dash: 'DD-MM-YYYY-hh-mm-A',
  },

  blog: {
    date: 'MMM D, YYYY',
  },
};

export const twentyOneCfrConfig = {
  minUsernameLength: 5,
  minPasswordLength: 6,
  autoLogoutInterval: 15,
};

export const ALTIUS_COMPANY_ID = 1;
export const EAST_CASTLE_COMPANY_ID = 12;
export const DR_CONGO_PLACE_ID = 44;
